import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { detectUserLanguage } from './utils/i18n';
import verifyUser from './containers/Auth/verifyUser';
import verifyToken from './containers/Auth/verifyToken';
import App from './containers/App';
// pages
import IndexPage from './pages/IndexPage';
import RewardsPage from './pages/RewardsPage';
import SignupConfirmPage from './pages/SignupConfirmationPage';
import ForgotConfirmPage from './pages/ForgotConfirmationPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import ErrorPage from './pages/ErrorPage';

const lang = detectUserLanguage();

export default store => (
  <Route
    onEnter={() => {
      verifyToken(store);
    }}
  >
    <Route path={`/(${lang})`} component={App}>
      <IndexRoute component={IndexPage} />
      <Route path="rewards" component={RewardsPage} />
      <Route path="signup-confirmation/:code" component={SignupConfirmPage} />
      <Route path="forgot-confirmation/:code" component={ForgotConfirmPage} />

      {/* Dashboard */}
      <Route
        path="dashboard"
        onEnter={() => {
          verifyToken(store);
        }}
        component={verifyUser('/#login')(DashboardPage)}
      />
      <Route
        path="profile"
        onEnter={() => {
          verifyToken(store);
        }}
        component={verifyUser('/#login')(ProfilePage)}
      />

    </Route>

    {/* Catch errors */}
    <Route component={App}>
      <Route path="*" component={ErrorPage} />
    </Route>

  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js